import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Swal from "sweetalert2/dist/sweetalert2.js"
import store from './store/store'
import VueForm from "vue-form"
import Multiselect from 'vue-multiselect'

import "sweetalert2/dist/sweetalert2.css"
import "vue-multiselect/dist/vue-multiselect.min.css"

import mainMixins from './mainMixins.js'

//window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

window.INSPIRO
Vue.mixin(mainMixins)
Vue.component('multiselect', Multiselect)

window.router = router
window.apiKS = "https://sistema.etciberoamerica.com/" //Producción
//window.apiKS = "https://etcapi.test/"//"http://apietc.loc/" //Desarrollo
window.axios = axios
window.Swal = Swal
window.VueForm = VueForm
window.Fire = new Vue()
window.Vue = Vue
window.user = null
window.headers = null
window.inspiroReady = false
//window.hostname = 'store-conalepon.etciberoamerica.com'//'store.etciberoamerica.com'//comentar para produccion
//window.apiConekta = 'key_Kf5K7iPrxBh52WmbkbrmWsA' // desarrollo
window.apiConekta = 'key_UAnsz7qgmkBmUSUQFE8CpdQ' // producción
window.hostname = location.hostname //esta linea debe estar descomentada en producción

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true
})

window.Toast = Toast

window.clientAPI = {
    'Content-Type': 'application/json',
    //Api de producción 
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMjQzYWRmYjAwOTU2MTkwM2I1YjZkNjdjNjM5MWU1MGM2Y2FiNmRiNjU0N2ZlZDExYzM5NzY4NmUxYjgwZGFiM2VmZjBjYjFlMzdmMzNmOTciLCJpYXQiOjE3NDY3MzMxNzkuMzMyODIsIm5iZiI6MTc0NjczMzE3OS4zMzI4MjIsImV4cCI6MTc3ODI2OTE3OS4zMzExMTcsInN1YiI6IjEiLCJzY29wZXMiOltdfQ.wtPk-euAoF_3XmMbEsecGBA_JKvfQmPNmmElwgiN8JrU6OlkuNG3tzIlae_DCUVaTATrzY1Q7S7OtHT4GDHTAAJd1Pfg_ARFtI_vADZ0Ibv3V26jKdh7DmvnbJd80EYVT8_kHpT7HrVI3Iv-U5kLZHKYWpoQ5FoI84x6La_QJ9IPqp4Z33qCIYXW4mongBtFsubAOMwxheuqVzD4HuZUoGg5EuMTP5c_LyYA9QhPt35kA-cRUQpr_dWsdVlw3CwQ1UA9e3p-cNS23ecO0XTP9ZBRDGzEBsKyAT73OjKD0fzh3G7gCh1znW_lSt4NaGxn_sz7gnCcJPGvxHJ7_mvhpBuiup4JRMbekyqYxKlpCC-G7yrEUx0I5hi1gNUDRp29rMb5KlTVFozFK1RkXaSNuDp9J6qhBned7nvED4K-rTFpFSKaFSE5ns7MNj5UMVh0aAxmyt80z-o8mtrIo12rybXCIGivRaZVRVWn0MGpu-w3j4VXBIqwOKTmXz1wsfQOVNaAfVvNyM88dDPkwfAmLV-j6hG3-nWLxgut2gfUbu1Wxw-6YLC4_HRS28aqL4DYTEkGHgkRSjVgRkNymL4gt1AOTqApak1PmxKCa72RzmOLHJEyVuNUdav-sny4fAy34N8Mbb9GyUCBMidJkBRhJYVAcegQEuD_3ypDkTIselc'
    
    //Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZFBlcnNvbiI6IjIzMzE2NyIsIm5iZiI6MTcyNDQzODgyNiwiZXhwIjoxNzU1OTc0ODI2LCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjUwMjIwIiwiYXVkIjoiTXlUZXN0QXBpIn0.7Un3XZ6T67epCdzcGrg-tgHQBSa_V0iIHt83yN4WOIM'
    //Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiZjRlMDMzNGUzOTliYjY1YzFhZTE5ZTRmZGZjOTc4MDJmNjA4Nzk4ZTM1ZGNkODZhZGFmOTk1YmFmM2EzMGNjODc5ZTk3NWJjNDgzZDE2NDAiLCJpYXQiOjE3NDI0MjU4MTUuNDU4MTMzLCJuYmYiOjE3NDI0MjU4MTUuNDU4MTM3LCJleHAiOjE3NzM5NjE4MTUuNDU0ODg3LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.DlgHSRjRhU5YeUvUxEwKMHJIBB5vFQlR87t_q_QijqOAmhQFvnVB3yUq8zifsdgH1ag9JiLc8-G-p4_wTcmWFqdfcJY61IkaFoom0A1fhl3x8G1SfCUkVJ_KAWG06ylZq1i2SDp5vtrTxDCUKNNS2f103XWwz6_Xfg6OaSjfhIzz5MGbwDN14J-aFWMQ0fEm3MjxMvRawtm1YN6C-FBJQN5iG4XssmgIphEHOfR0cFptA9mVEaw8GKq55bDocPAM-HfQQvNHD9fJ8SKLSRa-mKPDBQ4uvXLF0k9QjafEQrNevFSBSbe2Iuv54Xrvq-yKxZfXHjD1E-hxuEOb6rrlo9Md1cT02ImYta9x8m8gQZ7d6HAqpZk1bfR51Vzmu0J0lXxJmF1lqKUok9q6S6Sp4O8P3al1YKOSPPB73lM8V6RKafyGpcHQDc6npcbyrOMfIHbTluzjNLJ7nUfAizcr5xdyQd967Z8cyrwhgjhpCmGbUI-Cgxmj05-FbFnY8RUkBT2Q4QyC5AJ6eksj6cvr6e5dHDDcNc7bTOaSrz15JtjR2R23G0GK0PdHalEUuc4fhex27ngSj62ncKVKebrjK1xOr0GM823dqyEztZhmfw_F71RzdrQZj8dKvqAlt-MOXi0SNZX1gt_VUzAlXm273eoFJ6v7e_DxoZ4d2Bp7uiQ'
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
